import { FC, useState } from 'react';

import Select, { MultiValue } from 'react-select';

import { reactFormSelectMultiStyles } from '../react-select-styles';

export interface ISelectMultiOption {
  value: string;
  label: string;
}

export type ISelectMultiOptions = ISelectMultiOption[] | MultiValue<ISelectMultiOption>;

interface IProps {
  name: string;
  options: ISelectMultiOptions;
  value?: MultiValue<ISelectMultiOption>;
  isDisabled?: boolean;
  enableSelectAll?: boolean;
  // Defaults to react-select's "Select...".
  placeholder?: string;
  onChange?: (value: MultiValue<ISelectMultiOption>) => void;
}

export const SelectMulti: FC<IProps> = ({
  name,
  options,
  value = [],
  isDisabled = false,
  enableSelectAll = false,
  placeholder,
  onChange,
}) => {
  const [selectedOptions, setSelectedOptions] = useState<MultiValue<ISelectMultiOption>>(value);

  const allOptions = enableSelectAll
    ? [{ value: 'all', label: 'Select All' }, ...options]
    : options;

  const handleChange = (newValue: MultiValue<ISelectMultiOption>) => {
    if (enableSelectAll && newValue.some(option => option.value === 'all')) {
      const selected = allOptions.filter(option => option.value !== 'all');
      setSelectedOptions(selected);
      onChange?.(selected);
      return;
    }

    setSelectedOptions(newValue);
    onChange?.(newValue);
  };

  return (
    <div className='select-multi-container'>
      <Select
        isMulti
        options={allOptions}
        classNamePrefix='select'
        styles={reactFormSelectMultiStyles}
        value={selectedOptions}
        onChange={handleChange}
        isDisabled={isDisabled}
        placeholder={placeholder}
        maxMenuHeight={200}
      />

      {/* Hidden inputs for form submission */}
      {selectedOptions.map(option => (
        <input key={option.value} type='hidden' name={name} value={option.value} />
      ))}
    </div>
  );
};
